module.exports = __webpack_public_path__ + "img/sbzc_18.e1fd0c07.jpg";